import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence, useScroll, useMotionValueEvent } from 'framer-motion';
import { TelegramIcon, XIcon } from './icons';
import { TG_URL, X_URL, ALCOR_SWAP, ANT_BUBBLES_URL } from '../data';
import logo from '../../public/smartpepe.webp';
import '../styles/nav.css';

const LINKS = [
  { label: 'about', href: '#about' },
  { label: 'tokenomics', href: '#tokenomics' },
  { label: 'how to buy', href: '#how-to-buy' },
  { label: 'redeem', href: '#redeem' },
  { label: 'partners', href: '#partners' },
];

const Nav = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { scrollY } = useScroll();

  useMotionValueEvent(scrollY, 'change', (y) => setScrolled(y > 24));

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  const go = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <motion.header
      className={`nav ${scrolled ? 'nav--scrolled' : ''}`}
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
    >
      <div className="nav-inner">
        <a className="nav-brand" href="#top" onClick={(e) => { e.preventDefault(); go('#top'); }}>
          <img src={logo} alt="" className="nav-logo" />
          <span className="nav-wordmark">$KEK</span>
        </a>

        <nav className="nav-links" aria-label="Primary">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={(e) => { e.preventDefault(); go(l.href); }}>
              {l.label}
            </a>
          ))}
        </nav>

        <div className="nav-actions">
          <a className="nav-icon" href={TG_URL} target="_blank" rel="noopener noreferrer" aria-label="Telegram"><TelegramIcon /></a>
          <a className="nav-icon" href={X_URL} target="_blank" rel="noopener noreferrer" aria-label="X / Twitter"><XIcon /></a>
          <a className="btn btn-ghost nav-cta" href={ANT_BUBBLES_URL}>
            <img src="/antbubbles.svg" alt="" className="nav-ant-logo" aria-hidden="true" />
            AntBubbles
          </a>
          <a className="btn btn-primary nav-cta" href={ALCOR_SWAP} target="_blank" rel="noopener noreferrer">View on Alcor</a>
          <button className={`nav-burger ${open ? 'is-open' : ''}`} onClick={() => setOpen((o) => !o)} aria-label="Menu" aria-expanded={open}>
            <span /><span /><span />
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            className="nav-drawer glass"
            initial={{ opacity: 0, y: -12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -12 }}
            transition={{ duration: 0.3 }}
          >
            {LINKS.map((l) => (
              <a key={l.href} href={l.href} onClick={(e) => { e.preventDefault(); go(l.href); }}>{l.label}</a>
            ))}
            <a className="btn btn-ghost" href={ANT_BUBBLES_URL}>AntBubbles</a>
            <a className="btn btn-primary" href={ALCOR_SWAP} target="_blank" rel="noopener noreferrer">View on Alcor</a>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};

export default Nav;
